// extracted by mini-css-extract-plugin
module.exports = {"link":"Agreement-module__link___1a9eD"};